/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChildDTO
 */
export interface ChildDTO {
    /**
     * 
     * @type {string}
     * @memberof ChildDTO
     */
    batch?: string;
    /**
     * 
     * @type {string}
     * @memberof ChildDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChildDTO
     */
    materialCode?: string;
    /**
     * 
     * @type {number}
     * @memberof ChildDTO
     */
    qty?: number;
    /**
     * 
     * @type {string}
     * @memberof ChildDTO
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ChildDTO
     */
    uom?: string;
}

/**
 * Check if a given object implements the ChildDTO interface.
 */
export function instanceOfChildDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChildDTOFromJSON(json: any): ChildDTO {
    return ChildDTOFromJSONTyped(json, false);
}

export function ChildDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChildDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batch': !exists(json, 'batch') ? undefined : json['batch'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'materialCode': !exists(json, 'materialCode') ? undefined : json['materialCode'],
        'qty': !exists(json, 'qty') ? undefined : json['qty'],
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        'uom': !exists(json, 'uom') ? undefined : json['uom'],
    };
}

export function ChildDTOToJSON(value?: ChildDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch': value.batch,
        'id': value.id,
        'materialCode': value.materialCode,
        'qty': value.qty,
        'serialNumber': value.serialNumber,
        'uom': value.uom,
    };
}

